import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import useStyles from './LabResultsList.styles';
import { loadLabResults, selectListError, selectPaging } from '../../state';
import FlagIcon from '@material-ui/icons/Flag';
import MaterialTable, { Column } from 'material-table';
import { format } from 'date-fns';
import { LabResult } from '../../../../interfaces/lab-result';
import { useLastLocation } from 'react-router-last-location';

export default function LabeResultsList() {
  const error = useSelector(selectListError);
  const classes = useStyles();
  const dispatch = useDispatch();
  const paging = useSelector(selectPaging);
  const lastLocation = useLastLocation();
  const history = useHistory();

  if (error) {
    // TODO: implement correctly with retry operation
    return (
      <div className={classes.error}>
        {error}
      </div>
    )
  }

  const columns: Column<LabResult>[] = [
    { field: 'labRequestId', title: 'Request ID',
      render: (data: LabResult) => (<Link to={`/lab-results/${data.id}/`}>{data.labRequestId}</Link>),
      sorting: false
    },
    { field: 'sampleTakenDate', title: 'Sample Date',
      render: (data: LabResult) => {
        if (data.sampleTakenDate) {
          try {
            return format(new Date(data.sampleTakenDate), 'dd/MM/yyyy, hh:mm aaa');
          } catch(e) {
            return data.sampleTakenDate;
          }
        }
        return data.sampleTakenDate;
      },
      customSort: () => 0
    },
    { field: 'metadata.physicianOversight', title: 'Status', sorting: false },
    { field: 'metadata.globalNormality', title: 'Normality', sorting: false },
    { field: 'metadata.validity', title: 'Validity', sorting: false },
    { field: 'metadata.contact', title: 'Contact', sorting: false },
    { field: 'metadata.rateOfAgingEligible', title: 'RoA Eligible',
      render: (data: LabResult) => (data.metadata?.rateOfAgingEligible === true ? <FlagIcon /> : <div style={{height: 29}}></div>),
      sorting: false
    },
  ];

  const currentSortColumn = columns.find(({field}) => field === paging.sortField);
  if (currentSortColumn) {
    currentSortColumn.defaultSort = paging.sortType;
  }

  const backFromDetails = lastLocation && lastLocation.pathname.includes('/lab-results/');

  return (
    <MaterialTable
      title='Lab Results'
      columns={columns}
      data={(query) => {
        // backFromDetails is required to come around a bug with initialPage.
        const page = backFromDetails ? paging.page : query.page;
        return (dispatch(loadLabResults({
          ...paging,
          page,
          pageSize: query.pageSize,
          sortField: query.orderBy.field,
          sortType: query.orderDirection,
          search: query.search
        })) as any)
          .then((data: LabResult[]) => {
            if (backFromDetails) {
              history.push(`/lab-results?page=${page}`);
            }
            return {
              data: data.map(o => ({ ...o })),
              page,
              totalCount: data.length === query.pageSize ? Infinity : (query.pageSize * page) + data.length
            };
          })
      }}
      components={{
        Container: props => (
          <div style={{height: 'calc(100vh - 64px)'}}>
            {props.children}
          </div>
        ),
      }}
      localization={{
        pagination: {
          labelDisplayedRows: '{from}-{to}',
        },
      }}
      options={{
        headerStyle: { position: 'sticky', top: 0 },
        maxBodyHeight: 'calc(100vh - 128px - 53px)',
        thirdSortClick: false,
        paging: true,
        initialPage: 0,
        pageSize: paging.pageSize,
        searchText: paging.search,
        pageSizeOptions: [15, 30, 45],
        paginationType: 'normal',
        showFirstLastPageButtons: false,
        emptyRowsWhenPaging: false,
        debounceInterval: 500,
      }}
    />
  );
}
